/**
 * @file Identity select toggle.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IdentityAvatarContainer from '../../../containers/global/identity/IdentityAvatarContainer';
import IdentityName from '../../../containers/global/identity/IdentityNameContainer';
import Button from '../Button';
import { AVATAR_SIZE_52 } from '../../../constants/avatar-sizes';
import EditIcon from '../../icons/EditIcon';

const propTypes = {
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    last_name: PropTypes.string,
    current_photo: PropTypes.shape({
      id: PropTypes.string,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
        }),
      ),
    }),
  }).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  renderPrefix: PropTypes.func,
};

const IdentitySelectToggle = ({
  identity,
  onClick,
  className,
  renderPrefix,
}) => {
  const classes = classNames({
    'identity-select-toggle': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {renderPrefix && renderPrefix()}

      <div className="mr-2">
        <IdentityAvatarContainer identity={identity} size={AVATAR_SIZE_52} />
      </div>

      <IdentityName className="text-extra-bold" identity={identity} />

      {onClick && (
        <Button
          className="btn-identity-select-toggle-switch"
          btnStyle="link"
          onClick={onClick}
        >
          <EditIcon size="20" />
        </Button>
      )}
    </div>
  );
};

IdentitySelectToggle.propTypes = propTypes;

export default IdentitySelectToggle;
